import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import Modal from '@mui/material/Modal';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { TableCell, TableContainer, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const ItemEdit = ({ match }) => {
    const { id: recordId } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    const [formData, setFormData] = useState({
        Code: '',
        Name: '',
        PF: '',
        ISG: '',
        PurchaseRate: '',
        MRP: '',
        SalePrice: '',
        HSNCode: '',
        GSTRate: '',
        DiscountPercentage: '',
        StyleId: '',
        BrandId: '',
        UpdatedBy: userId
    });

    const [selectedStyle, setSelectedStyle] = useState('');
    const [selectedBrand, setSelectedBrand] = useState('');
    const [dropdownStyleOptions, setDropdownStyleOptions] = useState([]);
    const [dropdownBrandOptions, setDropdownBrandOptions] = useState([]);
    const [supplierOpen, setSupplierOpen] = useState(false);
    const [SupplierRateRelation, setSupplierRateRelation] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState(null);
    const [CustomerTypeOptions, setCustomerTypeOptions] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    useEffect(() => {
        fetchDropdownStyleOptions();
        fetchDropdownBrandOptions();
        fetchCustomerTypes();
        fetchItemDetails();
    }, []);

    const fetchDropdownStyleOptions = () => {
        fetchData('ItemApi', `/Style/${companyId}`, token)
            .then(response => setDropdownStyleOptions(response.response_data || []))
            .catch(error => console.error('Style dropdown fetch error:', error));
    };

    const fetchDropdownBrandOptions = () => {
        fetchData('ItemApi', `/Brand/${companyId}`, token)
            .then(response => setDropdownBrandOptions(response.response_data || []))
            .catch(error => console.error('Brand dropdown fetch error:', error));
    };

    const fetchCustomerTypes = () => {
        fetchData('BranchApi', `/${companyId}`, token)
            .then(response => setCustomerTypeOptions(response.response_data.map(ct => ({ label: ct.Name, value: ct.Id }))))
            .catch(error => console.error('Customer type fetch error:', error));
    };

    const fetchItemDetails = () => {
        fetchData('ItemApi', `/ItemDetails/${recordId}`, token)
            .then(response => {
                if (response.responseCode === '1111') {

                    const itemData = response.response_data.Item;
                    const childData = response.response_data.ItemBranchOpening;

                    setFormData({ ...itemData, UpdatedBy: userId });
                    setSelectedStyle(itemData.StyleId);
                    setSelectedBrand(itemData.BrandId);
                    if (childData) {
                        setSupplierRateRelation(childData);
                    }
                }
            })
            .catch(error => console.error('Item fetch error:', error));
    };

    const handleChange = e => {
        const { name, value, type } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? !prev[name] : value }));
    };

    const handleSubmit = e => {
        e.preventDefault();

        const itemVM = {
            Item: formData,
            ItemBranchOpening: SupplierRateRelation,  // for save the customer relation data            
        };

        updateData('ItemApi', `${recordId}`, { ...itemVM, UpdatedBy: userId }, token)
            .then(() => history.push('/ItemIndex'))
            .catch(error => console.error('Update error:', error));
    };

    const handleClickSupplierOpen = () => setSupplierOpen(true);
    const handleSupplierClose = () => setSupplierOpen(false);
    const handleCustomerTypeChange = selected => setSelectedCustomerType(selected);

    const handlesupplierSubmit = () => {
        if (selectedCustomerType) {
            const newSupplier = {
                BranchName: selectedCustomerType.label,
                BranchId: selectedCustomerType.value,
                Quantity: openingStock || '0',
            };
            setSupplierRateRelation(prev => [...prev, newSupplier]);
            setSelectedCustomerType(null);
            setSupplierOpen(false);
        }
    };
    const [openingStock, setOpeningStock] = useState('');

    const handleSupplierDelete = index => {
        setSupplierRateRelation(prev => prev.filter((_, i) => i !== index));
    };

    const [editIndex, setEditIndex] = useState(null);
    const [editedQuantity, setEditedQuantity] = useState('');

    const handleEditClick = (index, quantity) => {
        setEditIndex(index);
        setEditedQuantity(quantity);
    };

    const handleCancelEdit = () => {
        setEditIndex(null);
        setEditedQuantity('');
    };

    const handleSaveEdit = (index) => {
        const updatedList = [...SupplierRateRelation];
        updatedList[index].Quantity = editedQuantity;
        setSupplierRateRelation(updatedList);
        handleCancelEdit();
    };

    return (

        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className='w-full mb-2 flex items-center'>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> Item - Edit</h6>
                    <Button

                        style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                        onClick={handleSubmit}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> UPDATE
                    </Button>

                    <Button

                        component={Link}
                        to="/ItemIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                    </Button>
                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>


                <div className="w-full flex gap-6">
                    {/* LEFT 70% */}
                    <div style={{ flex: 7 }}>
                        <div className="w-full mb-4 flex">
                            <div className="w-4/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Item Name
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Name"
                                    name='Name'
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Item Code
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Code}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Code"
                                    name='Code'
                                />
                            </div>

                        </div>

                        <div className="w-full mb-4 flex">

                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Style
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedStyle ? 'fade-in' : 'fade-in'}`}
                                    value={selectedStyle}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedStyle(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            StyleId: selectedValue,
                                        }));
                                    }}
                                >
                                    <option value="">Select Style</option>
                                    {dropdownStyleOptions.map((Style) => (
                                        <option key={Style.Id} value={Style.Id}>
                                            {Style.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>


                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Brand
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedBrand ? 'fade-in' : 'fade-in'}`}
                                    value={selectedBrand}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedBrand(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            BrandId: selectedValue,
                                        }));
                                    }}
                                >
                                    <option value="">Select Item Group</option>
                                    {dropdownBrandOptions.map((Style) => (
                                        <option key={Style.Id} value={Style.Id}>
                                            {Style.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Discount %
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.DiscountPercentage}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Discount %"
                                    style={{ textAlign: 'right' }}
                                    name='DiscountPercentage'
                                />
                            </div>


                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Purchase Rate
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.PurchaseRate}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Purchase Rate"
                                    style={{ textAlign: 'right' }}
                                    name='PurchaseRate'
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    MRP
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.MRP}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter MRP"
                                    style={{ textAlign: 'right' }}
                                    name='MRP'
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sale Price
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SalePrice}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Sale Price"
                                    style={{ textAlign: 'right' }}
                                    name='SalePrice'
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GST Rate
                                    <span className="text-red-500">*</span>
                                </label>
                                {/* <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GSTRate}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter GST Rate"
                                    style={{ textAlign: 'right' }}
                                    name='GSTRate'
                                /> */}
                                 <select
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="GSTRate"
                                    value={formData.GSTRate}
                                     onChange={handleChange}
                                    style={{
                                        height: '32px',       // Adjust height
                                        fontSize: '14px',     // Font size
                                        paddingLeft: '8px',   // Optional padding
                                    }}
                                >
                                    <option value={0}>0</option>
                                    <option value={5}>5</option>
                                    <option value={18}>18</option>
                                    
                                </select>
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    HSN Code
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.HSNCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter HSN Code"
                                    name='HSNCode'
                                />
                            </div>
                        </div>
                    </div>

                    {/* RIGHT 30% */}
                    <div style={{ flex: 3 }}>
                        <div className='w-full mb-5' style={{ maxHeight: '350px', overflowY: 'auto', marginTop: '10px', borderRadius: '10px' }}>
                            <TableContainer component={Paper} style={{ backgroundColor: '#EDDFE0' }}>
                                <Table>
                                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                        <TableRow>
                                            <TableCell colSpan={6} sx={{ textAlign: 'center', fontWeight: 'bold', color: 'teal' }} onClick={handleClickSupplierOpen}>
                                                + Add Stock Details
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Branch</TableCell>
                                            <TableCell>Opening</TableCell>
                                            <TableCell align="center">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {/* <TableBody>
                                        {SupplierRateRelation.length > 0 ? SupplierRateRelation.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.BranchName}</TableCell>
                                                <TableCell>{item.Quantity}</TableCell>
                                                <TableCell align="center">
                                                    <FontAwesomeIcon icon={faTrash} onClick={() => handleSupplierDelete(index)} style={{ cursor: 'pointer', color: 'red' }} />
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center">No Branch details added yet.</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody> */}

                                    <TableBody>
                                        {SupplierRateRelation.length > 0 ? SupplierRateRelation.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.BranchName}</TableCell>

                                                <TableCell  style={{ width: '80px', padding: '4px', borderRadius: '4px',textAlign: 'right' }}>
                                                    {editIndex === index ? (
                                                        <input
                                                            type="number"
                                                            value={editedQuantity}
                                                            onChange={(e) => setEditedQuantity(e.target.value)}
                                                            style={{ width: '80px', padding: '4px', borderRadius: '4px',textAlign: 'right' }}
                                                        />
                                                    ) : (
                                                        item.Quantity
                                                    )}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {editIndex === index ? (
                                                        <>
                                                            <button onClick={() => handleSaveEdit(index)} style={{ marginRight: '5px', color: 'green' }}>💾</button>
                                                            <button onClick={handleCancelEdit} style={{ color: 'gray' }}>✖</button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FontAwesomeIcon
                                                                icon={faPenToSquare}
                                                                onClick={() => handleEditClick(index, item.Quantity)}
                                                                style={{ cursor: 'pointer', color: '#007bff', marginRight: '10px' }}
                                                            />
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                onClick={() => handleSupplierDelete(index)}
                                                                style={{ cursor: 'pointer', color: 'red' }}
                                                            />
                                                        </>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center">No Branch details added yet.</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>

                <Modal open={supplierOpen}>
                    <div className="fixed inset-0 flex items-start justify-center z-10">
                        <div className="p-4 sm:p-6 rounded-lg shadow-lg w-full sm:w-3/4 md:w-2/3 lg:w-1/2" style={{ height: '250px', overflowY: 'auto', marginTop: '50px', background: 'white' }}>
                            <h6 className="text-center font-bold" style={{ fontFamily: 'Times New Roman', color: 'darkmagenta' }}>BRANCH OPENING</h6>

                            {/* Flex container for Branch + Opening */}
                            <div className="w-full mb-4 flex">
                                <div className="w-3/5 mr-2">
                                    <label className="block text-xs font-bold text-brown-600 mb-2">Branch</label>
                                    <Select
                                        value={selectedCustomerType}
                                        onChange={handleCustomerTypeChange}
                                        options={CustomerTypeOptions}
                                        placeholder="Select Branch"
                                        isSearchable
                                    />
                                </div>

                                {/* Opening Input - 25% */}
                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">Opening</label>
                                    <input
                                        type="number"
                                        value={openingStock}
                                        onChange={(e) => setOpeningStock(e.target.value)}
                                        placeholder="Opening"
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    />
                                </div>
                            </div>


                            {/* Buttons */}
                            <DialogActions>
                                <Button onClick={handlesupplierSubmit} style={{ backgroundColor: 'green', color: 'white' }}>ADD</Button>
                                <Button onClick={handleSupplierClose} style={{ backgroundColor: 'red', color: 'white' }}>CLOSE</Button>
                            </DialogActions>
                        </div>
                    </div>
                </Modal>


            </form>
        </div>

    );
};

export default ItemEdit;
